import R from 'ramda'
import fs from 'fs'
import path from 'path'
import handlebars from 'handlebars'

export const readFileSyncAsString = (filePath: string): string => fs.readFileSync(filePath, 'utf8')

export const writeTemplateFileSync = R.curry((outputDirectory: string, filename: string, data: string): void => {
  const outputFilePath = path.resolve(outputDirectory, filename)
  fs.mkdirSync(outputDirectory, { recursive: true })
  fs.writeFileSync(outputFilePath, data, {
    encoding: 'utf-8',
  })
})

export const generateTemplate = R.curry((templatePath: string, values: Record<string, string>): string => {
  const templateAsString = readFileSyncAsString(templatePath)
  const template = handlebars.compile(templateAsString)
  return template(values)
})
